import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LoggingErrorBoundary, LoggerProvider } from '@shared-ui/logging'
import { ApiProvider } from '@shared-ui/api'
import { ThemeProvider } from '@shared-ui/theme'
import '@shared-ui/theme/index.css'
import './index.css'
import App from './App.tsx'
import { API_BASE, TOKEN_KEY } from './api/auth';
import { TenantGate } from '@shared-ui/tenant'

const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LoggingErrorBoundary>
      <LoggerProvider appSource="web-admin" apiBaseUrl={API_BASE} getAuthToken={getAuthToken}>
        <ApiProvider tokenKey={TOKEN_KEY}>
          <TenantGate>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </TenantGate>
        </ApiProvider>
      </LoggerProvider>
    </LoggingErrorBoundary>
  </StrictMode>,
)
